<div class="global-page-loader">
  <span class="lnr lnr-sync"></span>
</div>
